import styled from 'styled-components';
import { colors } from '@/theme/colors';
import { MultiLineText } from '../text/MultiLineText';
import { fonts } from '@/theme/fonts';
import { Images } from '@/assets';

interface AlertModalProps {
  message: string;
  onClose: (isConfirmButtonClick?: boolean) => void;
  buttonText: string;
  xButton?: boolean;
}

const AlertModal = ({
  message,
  onClose,
  buttonText,
  xButton = false,
}: AlertModalProps) => {
  return (
    <BackDrop>
      <ModalWrap>
        {xButton && <CloseButton onClick={() => onClose(false)}></CloseButton>}
        <ModalBox>
          <Message>
            <MultiLineText translationKey={message} lineHeight="140%" />
          </Message>
          <Button onClick={() => onClose(true)}>{buttonText}</Button>
        </ModalBox>
      </ModalWrap>
    </BackDrop>
  );
};

export default AlertModal;

const BackDrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: ${colors.overlay};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const ModalWrap = styled.div`
  position: relative;
  background: ${colors.white};
  border-radius: 8px;
  width: 395px;
  height: 232px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 9px;
  right: 10px;
  background-image: url(${Images.Ximg});
  width: 10.24px;
  height: 11px;
  background-position: center;
  background-size: contain;
`;

const ModalBox = styled.div`
  max-width: 360px;
  min-width: 288px;
  width: 100%;
  text-align: center;
`;

const Message = styled.div`
  font-size: 15px;
  margin-bottom: 40px;
  white-space: pre-line;
  color: ${colors.black};
`;

const Button = styled.button`
  height: 39px;
  width: 305px;
  background: #14122b;
  color: #ffffff;
  border-radius: 50px;
  font-weight: ${fonts.weight.bold};
  font-size: 15px;
  line-height: 140%;
`;
